export default __webpack_public_path__ + "static/media/jeans.ce04b332.jpg";